import { Row, Col } from 'react-bootstrap';
import MultiStepProgressBar from './MultiStepProgressBar';
import { Link } from 'react-router-dom';
import './ProviderRegistration.scss';
import useProviderSelfRegistration from './hooks/useProviderSelfRegistration';
import ProviderTypeSelection from './ProviderTypeSelection';
import ProviderInformation from './ProviderInformation';
import { BackAvatarSVG } from '../../img/GlobalSVG';
import UserProfileInformation from './UserProfileInformation';
import ReviewUserProfile from './ReviewUserProfile';
import ProviderRegistrationSuccess from './ProviderRegistrationSuccess';

const ProviderRegister = () => {
  const {
    currentStep,
    steps,
    providerType,
    AllowFacilityRegistration,
    AllowPhysicianRegistration,
    facilityFieldList,
    PhysicianFieldList,
    nextStep,
    prevStep,
    selectProviderType,
    dummyUserProfileInfo,
    userData,
    formData,
    handleInput,
    schema,
    PhysicianValues,
    facilityUserData,
    facilityFormData,
    handleFacilityInput,
    validateProviderFacility,
    facilityValues,
    userInfoFormSchema,
    validateExistingUserInfo,
    userInformationData,
    userFormData,
    unserInfoHandleInput,
    valideUser,
    providerFlowResponse,
    approvalRequiredFlag,
  } = useProviderSelfRegistration();

  return (
    <div className="container-offset">
      <div>
        <Row>
          <Col>
            <div className="mt-0 ml-0 mr-0 container-title d-flex align-items-center common-header-admin row">
              <div className="back-arrow col">
                <Link aria-label="back button" onClick={prevStep} to="#">
                  <BackAvatarSVG.BackArrowSVG />
                </Link>
              </div>
              <div className="col">
                <h1 id="greetings-time" className=" p-0 pb-2">
                  Registration
                </h1>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="">
        <MultiStepProgressBar currentStep={currentStep + 1} />
      </div>
      {steps[currentStep] === 'providerType' && (
        <ProviderTypeSelection
          selectProviderType={selectProviderType}
          AllowFacilityRegistration={AllowFacilityRegistration}
          AllowPhysicianRegistration={AllowPhysicianRegistration}
        />
      )}
      {steps[currentStep] === 'providerInfo' && (
        <ProviderInformation
          providerType={providerType}
          facilityFieldList={facilityFieldList}
          PhysicianFieldList={PhysicianFieldList}
          nextStep={nextStep}
          userData={userData}
          formData={formData}
          handleInput={handleInput}
          schema={schema}
          validateProviderFacility={validateProviderFacility}
          PhysicianValues={PhysicianValues}
          facilityUserData={facilityUserData}
          facilityFormData={facilityFormData}
          handleFacilityInput={handleFacilityInput}
          facilityValues={facilityValues}
        />
      )}
      {steps[currentStep] === 'userInfo' && (
        <UserProfileInformation
          userInfoFormSchema={userInfoFormSchema}
          validateExistingUserInfo={validateExistingUserInfo}
          nextStep={nextStep}
          userInformationData={userInformationData}
          userFormData={userFormData}
          unserInfoHandleInput={unserInfoHandleInput}
          valideUser={valideUser}
          approvalRequiredFlag={approvalRequiredFlag}
        />
      )}
      {steps[currentStep] === 'reviewInfo' && (
        <ReviewUserProfile
          providerType={providerType}
          dummyUserProfileInfo={dummyUserProfileInfo}
          userFormData={userFormData}
          formData={formData}
          facilityFormData={facilityFormData}
          providerFlowResponse={providerFlowResponse}
          approvalRequiredFlag={approvalRequiredFlag}
        />
      )}
      {steps[currentStep] === 'success' && (
        <ProviderRegistrationSuccess nextStep={nextStep} />
      )}
    </div>
  );
};

export default ProviderRegister;
